<div class="info">
	<div class="header">
		<div class="asset-type">
			<app-asset-type [widget]="widget()" />
		</div>

		@if (widget()?.assetClass === assetClassEnum.US_EQUITY) {
			<div class="tabs">
				@for (tab of tabList; track tab) {
					<app-button
						[appearance]="activeTab() === tab ? 'primary' : 'flat'"
						size="s"
						(clicked)="setTab(tab)"
					>
						{{ 'info.stocks.tabs.' + tab | translate }}
					</app-button>
				}
			</div>
		}
	</div>
	@switch (assetClass()) {
		@case (assetClassEnum.US_EQUITY) {
			<app-info-stocks
				[activeTab]="activeTab()"
				[liveTicker]="liveTicker()"
				[widget]="widget()"
			/>
		}
		@case (assetClassEnum.US_OPTION) {
			<app-info-options [widget]="widget()" />
		}
	}
</div>
